import {
  MOON_50,
  MOON_250,
  MOON_500,
  MOON_600,
  MOON_650,
} from '@wandb/weave/common/css/color.styles';
import {TextField} from '@wandb/weave/components/Form/TextField';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {FixedSizeTextArea} from '../../../Form/FixedSizeTextArea';

export const DrawerContents = styled.div<{scrollWidth?: number}>`
  padding: ${props => `${Math.max(60 - (props.scrollWidth ?? 0), 0)}px`} 24px
    20px 24px;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';

export const RegisteredCollectionDrawer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
RegisteredCollectionDrawer.displayName = 'S.RegisteredCollectionDrawer';

export const RegisteredCollectionDrawerMain = styled.div`
  flex: 1 1 auto;
  padding: 4px;
  padding-bottom: 300px;
  overflow-y: scroll;
`;
RegisteredCollectionDrawerMain.displayName = 'S.RegisteredCollectionDrawerMain';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  padding: 20px 0px;
`;
Header.displayName = 'S.Header';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
CloseButton.displayName = 'S.CloseButton';

export const PageLabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
  font-weight: 600;
  color: ${MOON_500};
`;
PageLabelRow.displayName = 'S.PageLabelRow';

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;
Description.displayName = 'S.Description';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const LabelSpan = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: ${MOON_500};
  font-style: italic;
`;
LabelSpan.displayName = 'S.LabelSpan';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const Footer = styled.div`
  display: flex;
  padding-top: 20px;
  justify-content: space-between;
`;
Footer.displayName = 'S.Footer';

export const FooterRightContent = styled.div`
  text-align: right;
  display: inline-flex;
  min-width: 50px;
  gap: 8px;
`;
FooterRightContent.displayName = 'S.FooterRightContent';

export const FooterLeftContent = styled.div`
  text-align: right;
  display: inline-flex;
  min-width: 50px;
  align-content: flex-start;
  vertical-align: middle;
`;
FooterLeftContent.displayName = 'S.FooterLeftContent';

export const HelpMessage = styled.div`
  color: ${MOON_600};
  font-size: 16px;
  line-height: 32px;
`;
HelpMessage.displayName = 'S.HelpMessage';

export const Divider = styled.div`
  background-color: ${MOON_250};
  height: 1px;
  margin-left: -20px;
  margin-right: -20px;
`;

export const StyledTextField = styled(TextField)`
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
StyledTextField.displayName = 'S.StyledTextField';

export const StyledTextArea = styled(FixedSizeTextArea)`
  min-height: 80px;
`;
StyledTextArea.displayName = 'S.StyledTextArea';

export const LinkCollectionNamePanel = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  color: ${MOON_600};
`;
LinkCollectionNamePanel.displayName = 'S.LinkCollectionNamePanel';

export const TextPanel = styled.div`
  width: fit-content;
  background-color: ${MOON_50};
  border-radius: 4px;
  padding: 18px 12px;
`;
TextPanel.displayName = 'S.TextPanel';

export const ArtifactNamePanel = styled.div`
  background-color: ${MOON_50};
  border-radius: 4px;
  padding: 8px 12px;
  font-weight: 600;
  line-height: 22.4px;
  color: ${MOON_650};
`;
ArtifactNamePanel.displayName = 'S.ArtifactNamePanel';
